import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Asset } from 'src/app/models/asset';
import { Folder } from 'src/app/models/folder';

@Component({
  selector: 'app-library-browser',
  templateUrl: './library-browser.component.html',
  styleUrls: ['./library-browser.component.css']
})
export class LibraryBrowserComponent implements OnInit {

  @Input() assetLibrary;
  @Output() selectedAsset: EventEmitter<string> = new EventEmitter<string>();
  @Output() folderSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() isPersonalBrowser = false;
  @Output() assetCardId: EventEmitter<{ folderId: any, section: string, libId: any }> = new EventEmitter<{ folderId: any, section: string, libId: any }>();
  @Input() isUpload = false;
  @Output() assetRelativePath: EventEmitter<any> = new EventEmitter<any>();
  @Output() parameterUrl: EventEmitter<any> = new EventEmitter<any>();
  params = '';
  contextmenu = false;
  contextmenuX = 0;
  contextmenuY = 0;
  confirmation = true;
  folderName;
  folderNameError = false;
  folderNameExists = false;
  currentRelativePath = [];
  modifyToken = false;
  folderNameRegex = new RegExp('^[a-zA-Z0-9-_ ]+$');
  folderNameFlag: boolean;
  prevLib: any;
  isShowNotificationAlert: boolean;
  showAlertMessage: string;
  theme_color: string;
  constructor(public httpService: HttpService, public userService: UserService, private router: Router, private location: Location,
    private activateRoute: ActivatedRoute) { }

  ngOnInit() {
    this.httpService.themeChange.subscribe(
      data => {
        this.theme_color = data.themeType;
      }
    );
    this.activateRoute.params.subscribe(param => {
      if (param.folder) {
        this.httpService.autoLoadTree = true;
      }
    });
    this.httpService.contextmenu = false;
    this.params = '';
  }

  modelChange(event) {
    console.log('received event :', event);
    if (event.target.value) {
      this.httpService.folder.name = event.target.value;
    }
  }

  // activates the menu with the coordinates
  onrightClick(event, lib) {
    if (null !== lib._id) {
      console.log(event);
      this.httpService.contextmenuX = event.clientX;
      this.httpService.contextmenuY = event.clientY - 128;
      this.httpService.contextmenu = true;
      this.httpService.folder = lib;
      console.log(this.httpService.folder);
      // setTimeout(() => {
      //   this.folderName = this.httpService.folder.name;
      // },100);
    }
  }
  // disables the menu
  disableContextMenu() {
    // console.log(this.contextmenu);
    this.httpService.contextmenu = false;
  }

  /**
   * Calls the library browser structute api to get the subfolders and the assets.
   * @param lib
   */
  addSubfolder(lib) {
    // if (this.httpService.autoLoadTree === true && sessionStorage.getItem('folderRefresh') === 'true') {
    //   sessionStorage.setItem('folderRefresh', 'false');
    // }
    /**
     * Checking Whether the user belongs to L2 L3 L4 nd restricting it to see assets in upload assets sections.
     */
    if (this.userService.loggendInUser.userGroup === 'L2' ||
      this.userService.loggendInUser.userGroup === 'L3' ||
      this.userService.loggendInUser.userGroup === 'L4') {
      if (lib._id === 'AssetsUploaded') {
        // alert("You don't have permission to upload the asset, hence no uploaded assets.");
        this.alertNotification("You don't have permission to upload the asset, hence no uploaded assets.");
        return;
      } else if (this.userService.loggendInUser.userGroup === 'L4' && lib._id === 'AssetsDownloaded') {
        // alert("You don't have permission to download the asset, hence no downloaded assets.");
        this.alertNotification("You don't have permission to download the asset, hence no downloaded assets.");
        return;
      }
    }
    this.httpService.changesearchResults(null, null, null, null);
    this.httpService.folder = lib;
    if (lib && null !== lib._id) {
      if (!this.httpService.autoLoadTree) {
        this.folderSelected.emit(true);
        this.selectedAsset.emit('@folder');
      }
      // Resetting the folders and asset list as it is not  on the refresh of folder or asset.
      // if ((lib.subFolders || lib.assetList) && !this.httpService.autoLoadTree &&
      //   (lib.subFolders && lib.subFolders.length > 0 || lib.assetList && lib.assetList.length > 0)) {
      //   lib.subFolders = [];
      //   lib.assetList = [];
      // } else {
      if (!this.isPersonalBrowser) {
        this.getLibraryFolderStructure(lib);
      } else {
        this.getPersonalBrowser(lib);
      }
      //}
    }
  }
  searchObject(element, currLib) {
    element.forEach(lib => {
      if (lib == currLib) {
        //we got what to remove here
        lib.subFolders = [];
        lib.assetList = [];
        this.prevLib = [];
        currLib = [];
        return;
      }
      else if (lib.subFolders != undefined && lib.subFolders.length > 0) {
        this.searchObject(lib.subFolders, currLib);
      }
    });
    return;
  }
  /**
   * Making the Library Folder Structure api call to get the folder and asset list for search the Lib tab.
   * @param lib - details of the library(like root or medical imaging etc)
   */
  public getLibraryFolderStructure(lib): void {

    this.httpService.getLibraryFolderStructure(lib._id, this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        if (this.prevLib != null) {
          let tempPrev = JSON.parse(JSON.stringify(this.prevLib));
          //remove previously clicked elem when clicking on another or potentially the same element.
          this.searchObject(this.assetLibrary, this.prevLib);
          if (tempPrev._id == lib._id)
            this.prevLib = lib;
        }
        if (this.prevLib != lib) {
          lib.subFolders = data.subFolders;

          lib.assetList = data.assetList;
          const ids = lib.assetList.map(asset => asset._id);
          this.prevLib = lib;

          // Emitting the parent folder id for getting asset card details from the search api
          this.assetCardId.emit({ folderId: lib._id, section: 'searchLib', libId: lib._id });

          lib.relativePath = data.relativePath;

          if (this.httpService.autoLoadTree && !(this.httpService.folderRefresh)) {
            this.constructTreeForAsset(this.currentRelativePath.slice(1), lib);
          } else if (this.httpService.autoLoadTree && this.httpService.folderRefresh) {
            this.httpService.folder2ndround = true;
            this.constructTreeForFolder(this.currentRelativePath.slice(1), lib);
          }
          // checking whether we are on the asset page or not
          let assetAbsent = true;
          this.activateRoute.params.subscribe(param => {
            let route = this.router.url.split('/');
            const f = route.length - 1;
            if (param.assetId && route[f] === param.assetId) {
              assetAbsent = false;
            }
          });
          if (assetAbsent) {
            this.params = '';
            if (this.httpService.folder.relativePath) {
              this.httpService.folder.relativePath.split(',')
                .forEach(rel => this.params = (this.params ? (this.params + '-') : '') + rel);
            } else {
              this.activateRoute.params.subscribe(param => {
                this.params = param.folder;
              });
            }
            this.parameterUrl.emit(this.params);
            this.httpService.changePath(this.params);
            this.httpService.autoLoadTree = false;
            this.location.go(`/val-assets/search/folders/${this.params}`);
          }
        }
        else
          this.prevLib = null;
      }, err => {
        console.error(err);
      }
    );
  }

  /**
   * Making the personal browser api call to get the folders and assetList for personal browser tab.
   * @param lib - details of the library(like root or medical imaging etc)
   */
  public getPersonalBrowser(lib): void {
    this.httpService.getPersonalBrowser(this.userService.loggendInUser.userEmailId, lib._id).subscribe(
      data => {
        lib.subFolders = data.subFolders;
        lib.assetList = data.assetList;
        lib.relativePath = data.relativePath;

        const ids = lib.assetList.map(asset => asset._id);
        this.assetCardId.emit({ folderId: ids, section: 'personalBrowser', libId: lib._id });
        if (lib._id === 'AssetsRecentlyViewed') {
          lib.assetList.sort((a: any, b: any) => new Date(b.viewedOn).getTime() - new Date(a.viewedOn).getTime());
          if (lib.assetList.length > 15) {
            lib.assetList = lib.assetList.slice(0, 15);
          }
        }
        if (this.prevLib == undefined) {
          this.prevLib = this.httpService.folder;
        }
        else {
          this.prevLib.assetList = [];
          if (this.prevLib != this.httpService.folder)
            this.prevLib = this.httpService.folder;
          else
            this.prevLib = undefined;
        }
      }, err => {
        console.error(err);
      }
    );
  }

  /**
   * TODO
   * @param asset 
   * @param lib 
   */
  onAssetSelect(asset, lib) {
    if (this.checkAssetVisibility(asset)) {
      this.httpService.changesearchResults(null, null, null, null);
      this.httpService.folder = lib;
      if (this.httpService.asset) {
        this.httpService.asset.selectedAsset = false;
      }
      asset.selectedAsset = true;
      this.httpService.asset = asset;
      this.location.go(`/val-assets/search/assets/${this.params}/${asset._id}`);
      if (!this.httpService.autoLoadTree) {
        this.selectedAsset.emit(asset._id);
      }
      this.httpService.autoLoadTree = false;
    }
    else {
      // alert("Not Permitted to view Private Asset")
      this.alertNotification("Not Permitted to view Private Asset");
    }
  }

  selectAsset(id) {
    if (!this.httpService.autoLoadTree) {
      this.selectedAsset.emit(id);
    }
  }

  addNewFolder() {
    if (!this.folderNameFlag) {
      return;
    }

    if (this.folderName === '' || this.folderName.trim() === '') {
      this.folderNameError = true;
    } else {
      const sameNameFolder = this.httpService.folder.subFolders.filter(
        folder => folder.name === this.folderName
      )
      if (sameNameFolder.length === 0) {
        this.folderNameExists = false;
        let newFolder = {
          parentId: this.httpService.folder._id,
          name: this.folderName,
          relativePath: `${this.httpService.folder.relativePath},${this.folderName}`
        }
        console.log(newFolder);
        //make a post call to create a folder
        this.httpService.createFolder(newFolder, this.userService.loggendInUser.userEmailId).subscribe(
          data => {
            console.log(data);
            // this.httpService.folder.subFolders[0].name = this.folderName;
            this.httpService.folder.subFolders = [];
            this.addSubfolder(this.httpService.folder);
          }, err => console.log(err)
        )
      } else {
        this.folderNameExists = true;
        // this.folderName = "Folder name already exists";
      }
    }
  }

  removeFolder() {
    this.httpService.folder.subFolders.splice(0, 1);
  }

  renameFolder() {
    let newFolder = {
      parentId: this.httpService.folder._id,
      name: this.folderName,
      relativePath: `${this.httpService.folder.relativePath},${this.folderName.split(' ').join('%40')}`
    }
    console.log(newFolder);
  }

  /**
   * This function is responsible for constructing the library browser tree.
   * @param relativePath : relative path of the selected folder.
   * @param lib : library folder.
   */
  constructTreeForFolder(relativePath: string[], lib) {

    this.currentRelativePath = relativePath;
    this.httpService.autoLoadTree = true;
    let folderDir;

    // If library is null or undefined then assign asset library to folder directory.
    if (!lib) {
      folderDir = this.assetLibrary[0].subFolders;
      const folder = folderDir.find(f => f.name.trim() === relativePath[0].trim());
      this.addSubfolder(folder);
    } else {

      folderDir = lib[0];

      // If we are refreshing the browser then this condition will execeute
      if (relativePath.length >= 1 && !(this.httpService.folderRefresh)) {
        folderDir = folderDir.subFolders;
        const folder = folderDir.find(f => f.name.trim() === relativePath[0].trim());
        this.addSubfolder(folder);
      } else if (relativePath.length >= 1 && this.httpService.folderRefresh) {
        if (this.httpService.folder2ndround) {
          folderDir = lib;
        }
        folderDir = folderDir.subFolders ? folderDir.subFolders : folderDir;
        const folder = folderDir.find(f => f.name.trim() === relativePath[0].trim());
        if (folder) {
          this.addSubfolder(folder);
        }
      }
    }
  }

  /**
   * 
   * @param relativePath 
   * @param lib 
   */
  constructTreeForAsset(relativePath: string[], lib) {
    this.currentRelativePath = relativePath;
    this.httpService.autoLoadTree = true;
    let folderDir;
    let assetLists;
    if (!lib) {
      folderDir = this.assetLibrary[0].subFolders;
      //assetLists = this.assetLibrary[0].assetList;
      let folder = folderDir.find(f => f.name.trim() === relativePath[0].trim());
      this.addSubfolder(folder);
    } else {
      folderDir = lib;
      if (relativePath.length > 1) {
        folderDir = folderDir.subFolders;
        let folder = folderDir.find(f => f.name.trim() === relativePath[0].trim());
        this.addSubfolder(folder);
      }
      else {
        assetLists = folderDir.assetList;
        if (relativePath[0]) {
          let file = assetLists.find(f => f.name.trim() === relativePath[0].trim());
          if (file) {
            if (this.httpService.asset) {
              // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",this.httpService.asset);
              this.httpService.asset.selectedAsset = false;
              // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",this.httpService.asset);
            }
            file.selectedAsset = true;
            this.httpService.asset = file;
            this.httpService.autoLoadTree = false;
          } else {
            this.router.navigateByUrl("/val-assets/search");
          }
        }
      }
    }
  }

  allowDrop(ev: any) {
    ev.preventDefault();
  }

  drag(ev: any, asset: Folder, lib: Folder) {
    console.log(ev);
    this.onAssetSelect(asset, lib);
    // this.selectAsset(asset._id);
    //ev.dataTransfer.setData("asset", ev.target.id);
    this.httpService.dragedAsset = asset;
    this.httpService.dragedAssetFolder = lib;
  }

  drop(ev: any, lib: any) {
    let asset: Asset;
    this.modifyToken = false;
    console.log('>>>>>>>>>>>>>>', this.httpService.dragedAsset, lib);
    this.httpService.getAssetById(this.httpService.dragedAsset._id, this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        asset = data;
        asset.attributes.uploader = asset.attributes.uploader.split("@")[0];
        if (asset.attributes) {
          this.modifyAsset(asset);
        }
        if (!this.modifyToken) {
          // alert("You don't have access to modify the asset");
          this.alertNotification("You don't have access to modify the asset");
          return;

        }
        if (confirm(`the asset will move to ${lib.name}`)) {
          this.httpService.moveAsset(this.httpService.dragedAsset._id, lib._id, this.userService.loggendInUser.userEmailId).subscribe(
            (data: any) => {
              lib.subFolders = data.subFolders;
              lib.assetList = data.assetList;
              lib.relativePath = data.relativePath;
              this.assetRelativePath.emit(data.relativePath);
              this.httpService.dragedAssetFolder.assetList.splice(this.httpService.dragedAssetFolder.assetList.indexOf(this.httpService.dragedAsset), 1);
              this.userService.loggendInUser.assetsUploaded.push(this.httpService.dragedAsset._id);
              this.updateFolderDetails(lib, this.httpService.dragedAsset._id);
              //lib.assetList.push(this.httpService.dragedAsset);
            }, err => {
              // if (!lib.assetList) lib.assetList = [];
              // lib.assetList.push(this.httpService.dragedAsset);
              // console.log(this.httpService.dragedAsset);
              // this.httpService.dragedAssetFolder.assetList.splice(this.httpService.dragedAssetFolder.assetList.indexOf(this.httpService.dragedAsset), 1);
              console.error(err);
            }, () => {
              console.log('done');
            }
          )
        }
      }, err => {
        console.error(err);
      },
    );

  }

  fetchCardDetails(event) {
    this.assetCardId.emit(event);
  }

  assetRelativePathRecive(event) {
    this.assetRelativePath.emit(event);
  }

  modifyAsset(asset): void {
    const toekn = this.userService.loggendInUser.tokens.filter(token => token.function === 'Modify');
    if (toekn[0] && toekn[0].permissions) {
      toekn[0].permissions.forEach(permission => {
        let isPrimaryUser = false;
        let isCommerciallyReady = false;
        let hasCommercialAccess = false;

        // checking if the logged in user is uploader or the Primary contact for the selected asset.
        if (this.userService.loggendInUser.userEmailId === asset.attributes.uploader
          || this.userService.loggendInUser.userEmailId === asset.attributes.primaryContact.emailId) {
          isPrimaryUser = true;
        }

        // Checking if the asset is commercially ready.
        if (asset.attributes.productStatus === 1) {
          isCommerciallyReady = true;
        }

        // Checking if the user has permissions to perform opertaion on commercial assets.
        if (permission[1] === 'Commercial') {
          hasCommercialAccess = true;
        }

        if (permission[0] === 'Self' && isPrimaryUser
          && hasCommercialAccess && isCommerciallyReady) {
          this.modifyToken = true;
        } else if (permission[0] === 'Self' && isPrimaryUser
          && !hasCommercialAccess && !isCommerciallyReady) {
          this.modifyToken = true;
        } else if (permission[0] === 'Others' && !isPrimaryUser
          && hasCommercialAccess && isCommerciallyReady) {
          this.modifyToken = true;
        } else if (permission[0] === 'Others' && !isPrimaryUser
          && !hasCommercialAccess && !isCommerciallyReady) {
          this.modifyToken = true;
        }
      });
    }
  }

  parameterUrl2(event: any) {
    this.parameterUrl.emit(event);
  }

  updateFolderDetails(folder, assetId) {
    this.httpService.folder = folder;
    // checking whether we are on the asset page or not
    let assetAbsent = true;
    this.activateRoute.params.subscribe(param => {
      let route = this.router.url.split('/');
      const f = route.length - 1;
      if (param.assetId && route[f] === param.assetId) {
        assetAbsent = false;
      }
    });
    if (!assetAbsent) {
      this.httpService.fetchAsset.next(assetId);
    }
  }
  /**
   * To validate the asset name
   * @param str - asset name 
   */
  folderNameValidation(str: string) {
    //The asset name must be alphanumeric with _ and - allowed.It should not end with _ and -
    if (this.folderNameRegex.test(str) &&
      (!str.endsWith('-') && !str.endsWith('_')) &&
      (str.slice(0, 1) !== '_' && str.slice(0, 1) !== '-')) {
      this.folderNameFlag = true;
    } else {
      this.folderNameFlag = false;
    }
  }

  checkAssetVisibility(asset): boolean {
    if (asset.visibility == 1 || asset.primary == this.userService.loggendInUser.userEmailId) {
      return true;
    }
    return false;
  }


  alertNotification(message){
    this.isShowNotificationAlert = true;
    this.showAlertMessage = message;
    setInterval(()=>{
      this.isShowNotificationAlert = false;
    },5000);
  }
}

